import { useRoutes } from 'react-router-dom';

const ViewWrapper = ({ router }) => {
    let elements = useRoutes(router);
    return elements;
};

export default ViewWrapper;
